import PropTypes from 'prop-types'
import React from 'react'
import { Box } from '@mui/material'

import { formatDistanceToNowAbbreviated, isBirthday } from '@hapana/shared/utils/date.util'
import MostRecentCardAnimated from '@components/check-in-widget/most-recent-card/most-recent-card-animated.component'
import { useSiteConfiguration } from '@hapana/shared/web/hooks/siteConfiguration.hooks'

import { styles } from './previous-check-in.styles'

const parseDateTime = (dt) => (dt ? new Date(Number(dt)) : null)

const PreviousCheckIn = ({ checkIns, newCheckIns }) => {
  const newCheckInsWithoutFirst = newCheckIns.slice(1)
  const { data: configurations } = useSiteConfiguration()

  const timezone = configurations?.timezone
  return (
    <Box sx={styles.checkinWrapper}>
      {newCheckInsWithoutFirst.map((item) => {
        const {
          id,
          clientId,
          datetime,
          dateTime,
          status,
          payments,
          membership,
          nextSession,
          client: {
            firstName,
            lastName,
            profileImage,

            siteNotes,
            siteAlertedProperties,
            sitesInIntroOffer,
            formsPending,
            homeLocationIds,
            birthday,
            totalCheckInCount,
            siteInformation,
          },
          homeSiteName,
          failReason,
        } = item.checkin

        // Manual check-ins from the mutation response use `dateTime` (ms timestamp string)
        // while FCM/subscription check-ins use `datetime` (ISO string)
        const resolvedDate = datetime ? new Date(datetime) : parseDateTime(dateTime)
        const resolvedDateTimeStr = datetime ?? dateTime

        return (
          <MostRecentCardAnimated
            profileImg={profileImage}
            name={`${firstName} ${lastName}`}
            firstName={`${firstName}`}
            status={status}
            date={resolvedDate ? formatDistanceToNowAbbreviated(resolvedDate) : ''}
            checkInTime={resolvedDateTimeStr}
            membership={membership}
            nextSession={nextSession}
            key={id}
            payments={payments}
            location={homeSiteName}
            clientId={clientId}
            isInitiallyOpen
            failReason={failReason}
            formsPending={formsPending}
            homeSites={homeLocationIds}
            totalCheckInCount={totalCheckInCount}
            siteInformation={siteInformation}
            birthday={isBirthday(birthday, resolvedDate, timezone) && birthday}
            siteNotes={siteNotes}
            siteAlertedProperties={siteAlertedProperties}
            sitesInIntroOffer={sitesInIntroOffer}
            checkInId={id}
          />
        )
      })}
      {checkIns.map((item, index) => {
        const {
          checkInId: id,
          clientId,
          dateTime,
          status,
          failedInvoices,
          stagedInvoices,
          client: {
            firstName,
            lastName,
            profileImage,
            totalCheckInCount,
            siteInformation,
            dateOfBirth,
            homeSiteName,
            homeLocationIds,
            notes: siteNotes,
          },
          nextSession: rawNextSession,
          service,
          failReason,
        } = item

        const datetime = parseDateTime(dateTime)
        const membership = service ? { title: service.serviceName } : null
        const nextSession = rawNextSession
          ? { title: rawNextSession.sessionName, datetime: rawNextSession.sessionDateTime }
          : null
        const payments = {
          failed: failedInvoices?.map((inv) => ({
            invoiceId: inv.invoiceId,
            label: inv.description,
            price: inv.amount,
            datetime: inv.dueDate,
          })),
          outstanding: stagedInvoices?.map((inv) => ({
            invoiceId: inv.invoiceId,
            label: inv.description,
            price: inv.amount,
            datetime: inv.dueDate,
          })),
        }

        const isOpen = index === 0 && newCheckIns.length > 0

        return (
          <MostRecentCardAnimated
            profileImg={profileImage}
            name={`${firstName} ${lastName}`}
            firstName={`${firstName}`}
            status={status}
            date={datetime ? formatDistanceToNowAbbreviated(datetime) : ''}
            checkInTime={dateTime}
            membership={membership}
            nextSession={nextSession}
            key={id}
            payments={payments}
            location={homeSiteName}
            clientId={clientId}
            isInitiallyOpen={isOpen}
            failReason={failReason}
            index={index}
            birthday={isBirthday(dateOfBirth, datetime, timezone) && dateOfBirth}
            totalCheckInCount={totalCheckInCount}
            siteInformation={siteInformation}
            siteNotes={siteNotes}
            homeSites={homeLocationIds}
            checkInId={id}
          />
        )
      })}
    </Box>
  )
}

PreviousCheckIn.propTypes = {
  checkIns: PropTypes.array,
  newCheckIns: PropTypes.array,
}

export default PreviousCheckIn
